import { clsx } from 'clsx';
import { type TFunction } from '@pkgs/components/providers';
import { ImageAiType } from '@ev-tech/search-modules-api';

import styles from './AiBadge.module.css';

export type AiBadgeSize = 's' | 'm' | 'l';
export type AiBadgeOffset = 'xxs' | 'xs' | 's' | 'm';
export type AiBadgeSide = 'left' | 'right' | 'center';

type Props = {
  t: TFunction;
  translationKey?: string;
  size: AiBadgeSize;
  offset: AiBadgeOffset;
  mobileOffset?: AiBadgeOffset;
  side?: AiBadgeSide;
  isPrivateOffice?: boolean;
  aiType?: ImageAiType;
  className?: string;
};

export const AiBadge = ({
  t,
  translationKey,
  offset,
  size,
  mobileOffset,
  side = 'right',
  isPrivateOffice = false,
  aiType,
  className,
}: Props) => {
  if (!translationKey || !aiType) return null;

  if (!(aiType === ImageAiType.MODIFIED || aiType === ImageAiType.GENERATED)) return null;

  return (
    <span
      className={clsx(styles.root, className)}
      data-offset={offset}
      data-size={size}
      data-mobile-offset={mobileOffset}
      data-side={side}
      data-private-office={isPrivateOffice}
      data-testid="search-components_ai-badge"
    >
      {t(translationKey)}
    </span>
  );
};
